import { createContext, PropsWithChildren, useContext } from 'react';
import * as React from 'react';
import { DocumentTitle, ProjectName } from '@yakoffice/shared-components';
import { useParams } from 'react-router-dom';

export interface IPageTitleContext {
  setPageTitle: (titleValues?: string[]) => void;
}

export const PageTitleContext = createContext<IPageTitleContext>(null!);

const PageTitleContextProvider: React.FC<PropsWithChildren> = ({ children }) => {

  const { projectId } = useParams() as { projectId: string };

  const setPageTitle = (titleValues?: string[]) => {

    if (titleValues?.length === 0 || titleValues === undefined)
      DocumentTitle('Publisher - ' + ProjectName(projectId));

    else {
      const title = titleValues.join(' - ') + ' - Publisher - ' + ProjectName(projectId);
      DocumentTitle(title);
    }
  };

  return (
    <PageTitleContext.Provider value={{ setPageTitle }}>
      {children}
    </PageTitleContext.Provider>
  );
};

const usePageTitle = () => useContext(PageTitleContext);

export { PageTitleContextProvider, usePageTitle };
